import React, { FC, useMemo, useState } from 'react';

import { Range } from 'slate';

import FormulaEditorToolbarIcon from '../assistant/components/FormulaEditorToolbarIcon';

//constants
import ICONS from '../../../../constants/icons';

// components
import LabelHistoryModal from './LabelHistoryModal';

interface LabelHistoryMainProps {
    selectedElement?: { [key: string]: any };
    formulaId?: number;
    currentSelection?: Range;
}

const LabelHistoryMain: FC<LabelHistoryMainProps> = ({
    selectedElement,
    formulaId,
    currentSelection,
}) => {
    const [showLabelHistoryModal, setShowLabelHistoryModal] =
        useState<boolean>(false);

    const isDisabled = useMemo<boolean>(() => {
        return !selectedElement || !formulaId;
    }, [selectedElement, formulaId]);

    const title = useMemo<string>(() => {
        return isDisabled
            ? 'Select a field or component first'
            : 'View label history';
    }, [isDisabled]);

    return (
        <>
            <FormulaEditorToolbarIcon
                isDisabled={isDisabled}
                Icon={ICONS.labelHistory}
                title={title}
                onIconClick={() => setShowLabelHistoryModal(true)}
            />
            {showLabelHistoryModal && formulaId && selectedElement && (
                <LabelHistoryModal
                    handleClose={() => setShowLabelHistoryModal(false)}
                    selectedElement={{ selectedElement }}
                    formulaId={formulaId}
                    currentSelection={currentSelection}
                />
            )}
        </>
    );
};

export default LabelHistoryMain;
